<p-dialog 
  [(visible)]="displayDialog" 
  [style]="{width: '90vw'}" 
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onDialogClosed()"
  header="Scripts">
  
  <div>
    <div class="card-header mb-4">
      <div class="title-section">
      </div>
      <div class="search-section">
        <div class="button-section">
          <span class="p-input-icon-left search-input">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="table.filterGlobal($event.target.value, 'contains')"
              placeholder="Buscar..."
              class="p-inputtext-sm"
            appPermissionControl="P280K0001">
          </span>
          <button mat-flat-button class="btn-new" (click)="openNew()" appPermissionControl="P280B0001">
            <mat-icon>add</mat-icon>
            Nuevo Script
          </button>
        </div>
      </div>
    </div>

    <p-table
      #dt
      [value]="scripts"
      [columns]="displayedColumns"
      [paginator]="true"
      [rows]="10"
      [scrollable]="true"
      [scrollHeight]="'calc(100vh - 400px)'"
      styleClass="p-datatable-gridlines"
      [resizableColumns]="true"
      [autoLayout]="true"
      responsiveLayout="scroll"
      [loading]="loading"
      [globalFilterFields]="['iNumScript', 'sTexto']"
     appPermissionControl="P280T0001">
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P280C0001">
            {{ col.header }}
            <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-script>
        <tr>
          <td *ngFor="let col of displayedColumns" class="td-prime">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'actions'">
                <div class="d-flex gap-2 justify-content-center">
                  <button
                    pButton
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-info p-button-text"
                    pTooltip="Editar"
                    (click)="editScript(script)"
                   appPermissionControl="P280B0002"></button>
                  <button
                    pButton
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-danger p-button-text"
                    pTooltip="Eliminar"
                    (click)="deleteScript(script)"
                   appPermissionControl="P280B0003"></button>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ script[col.field] }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center td-prime">
            <span *ngIf="scripts.length === 0 && !loading">No hay datos para mostrar</span>
            <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <app-nuevo-script-dialog
    [(displayDialog)]="displayNuevoScriptDialog"
    [cuestionario]="cuestionario"
    [preguntaSeleccionada]="preguntaSeleccionada"
    [scriptSeleccionado]="scriptSeleccionado"
    [opcionSeleccionada]="opcionSeleccionada"
    (onHide)="onNuevoScriptDialogClosed($event)">
  </app-nuevo-script-dialog>

  <p-toast position="bottom-right"></p-toast>
</p-dialog> 